import React from 'react';
import { lighten } from 'polished';
import styled, { css } from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import CoreImage from 'gatsby-theme-core/src/components/image';
import Content from 'gatsby-theme-core/src/components/content';
import Section from '../components/section';

const Grid = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 2rem;
  grid-template-columns: 1fr;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    grid-template-columns: 1fr 2fr;
  }
`;

const Quote = ({
  rowOptions,
  text,
  image,
  author,
  description,
  className,
}) => {
  const standoutVariant = rowOptions?.backgroundColor === 'standout';
  const Wrapper = image ? Grid : 'div';
  return (
    <Section
      className={className}
      id={rowOptions?.sectionId || ''}
      backgroundColor={rowOptions?.backgroundColor}
      hideBottomSpacing={rowOptions?.hideBottomSpacing}
      hideTopSpacing={rowOptions?.hideTopSpacing}
      hideRow={rowOptions?.hideRow}
    >
      <StyledContainer $extraSmall>
        <Wrapper>
          {image && (
            <CoreImage
              image={image}
              alt={author}
            />
          )}
          <div css="position: relative;">
            <BackgroundIcon
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 251 201"
              standoutVariant={standoutVariant}
            >
              <g fill="none" fillRule="evenodd">
                <g fill="currentColor">
                  <path d="M54.61 201c15.758 0 28.799-5.29 39.123-15.868 10.324-10.58 15.486-24.278 15.486-41.096 0-21.157-8.15-36.89-24.452-47.198L119 0H66.02L14.672 98.466c-4.89 9.222-8.558 17.089-11.003 23.599C1.223 128.575 0 135.899 0 144.036c0 17.36 5.298 31.195 15.894 41.502C26.49 195.846 39.395 201 54.61 201zm132 0c15.758 0 28.799-5.29 39.123-15.868 10.324-10.58 15.486-24.278 15.486-41.096 0-21.157-8.15-36.89-24.452-47.198L251 0h-52.98l-51.349 98.466c-4.89 9.222-8.558 17.089-11.003 23.599-2.445 6.51-3.668 13.834-3.668 21.971 0 17.36 5.298 31.195 15.894 41.502C158.49 195.846 171.395 201 186.61 201z" />
                </g>
              </g>
            </BackgroundIcon>
            <ContentWrapper standoutVariant={standoutVariant}>
              <Content $content={text} />
            </ContentWrapper>
            <Author standoutVariant={standoutVariant}>
              {author}
            </Author>
            <Description standoutVariant={standoutVariant}>
              {description}
            </Description>
          </div>
        </Wrapper>
      </StyledContainer>
    </Section>
  );
};

const Author = styled.div`
  position: relative;
  text-transform: uppercase;
  color: ${({ theme }) => theme.secondaryColor};
  font-weight: 600;
  ${({ standoutVariant }) => standoutVariant && css`
    color: white;
  `};
`;
const Description = styled.span`
  position: relative;
  display: block;
  line-height: 150%;
  margin-top: .25rem;

  ${({ standoutVariant }) => standoutVariant && css`
    color: white;
  `};
`;
const BackgroundIcon = styled.svg`
  position: absolute;
  top: 0;
  right: 50%;
  transform: translateX(50%);
  height: 14rem;

  color: ${({ standoutVariant, theme }) => (standoutVariant
    ? lighten(0.1, theme.secondaryColor)
    : '#F4F4F4'
  )};
`;
const ContentWrapper = styled.div`
  margin: 0 0 1.5rem 0;
  position: relative;
  ${({ standoutVariant }) => standoutVariant && css`
    color: white;
  `};
  p {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
  }
`;

const StyledContainer = styled(Container)`
  position: relative;
  min-height: 14rem;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export default Quote;
